<template>
  <v-container
      class="fill-height"
      :fluid="true"
  >
    <v-row justify="center">
      <v-col align-self="center">
        <v-card
            v-if="!this.mailSent"
            class="mx-auto px-6 py-8"
            max-width="400"
        >
          <p class="text-h5 mb-6">Forgot password</p>
          <v-form
              v-model="valid"
              ref="forgot"
          >
            <v-text-field
                v-model="email"
                :readonly="loading"
                :rules="emailRules"
                :clearable="true"
                class="mb-2"
                label="Email"
            />
            <p v-show="errorMessage !== null" class="text-subtitle-2 text-red">{{ errorMessage }}</p>
            <br/>

            <v-btn
                :block="true"
                color="success"
                size="large"
                variant="elevated"
                v-on:click="forgotPassword(email)"
            >
              Send forgot mail
            </v-btn>
            <v-overlay
                v-model="loading"
                :persistent="loading"
                :contained="true"
                class="align-center justify-center"
            >
              <v-progress-circular
                  indeterminate
                  size="64"
              />
            </v-overlay>
          </v-form>
        </v-card>
        <v-card
            v-if="this.mailSent"
            class="mx-auto px-6 py-8"
        >
          <p class="text-h5">Forgot mail sent</p>
          <p class="text-subtitle-1">If submitted mail associated with existed account you will receive forgot email.
            Please check your mailbox for further instructions.</p>
          <p class="text-subtitle-2">If you don’t see this email in your inbox within 15 minutes, look for it in your
            junk mail folder. If you find it there, please mark it as “Not Junk”.
          </p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {auth} from "@/common/auth";
import {router} from "@/router";
import {readonly} from "vue";
import {messages} from "@/common/enum/messages";

export default {
  name: 'ForgotView',
  data() {
    return {
      redirectionLink: readonly({
        name: 'home'
      }),
      email: '',
      valid: null,
      loading: false,
      errorMessage: null,

      mailSent: false,

      emailRules: [
        v => !!v || 'E-mail is required',
        v => /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ],
    };
  },
  mounted() {
    if (auth.isAuthorized()) {
      router.push(this.redirectionLink)
    }
  },
  methods: {
    forgotPassword(email) {
      this.$refs.forgot.validate()
      if (this.valid !== true) {
        return
      }

      this.resetErrorMessage()
      this.loading = true
      auth.sendForgotMail(email, (responseMessage) => {
        this.loading = false
        if (responseMessage !== null) {
          this.errorMessage = responseMessage.length === 0 ? messages.en.forgot_view.fatal_error : responseMessage
          return
        }

        this.mailSent = true
      })
    },
    resetErrorMessage() {
      this.errorMessage = null
    }
  },
}
</script>

<style scoped>

</style>